/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const useEffectWhenStateParamsReady = (effect, deps, stateParamsReady) => {
  useEffect(() => {
    if (!stateParamsReady) return;
    const cleanup = effect();
    // eslint-disable-next-line consistent-return
    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, [stateParamsReady, ...deps]);
};

export default useEffectWhenStateParamsReady;
